import { HttpHeaders, HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ApiService } from '../../shared/services';
import { IGlobalSearchParam } from '../../shared/models/Global-Search.model';
import { IUserDetails } from '../models/user.model';
import { ICompanyAdminEdit, ICompanyClientDocumentEdit, ICompanyCOIChangeRequestDetails, ICompanyDeliveryTeamsEdit,
         ICompanyDetailsEdit, ICompanyDocuments, ICompanyEdit, ICompanyNotes, ICompanyProfileEdit, ICompanyReferenceEdit, 
         IUpdateVendorCategory,IVendorInvoiceEligibility, ICompanyOnboardingDocumentRequestDetails, ICompanyOnboardingDocumentRequestDetailsCOI } from '../models/company.model';
import { MSAType } from 'src/app/shared/enums/EnumsVMS';

@Injectable({
  providedIn: 'root'
})
export class CompanyService {
  constructor(
    private http: HttpClient,
    private apiService: ApiService
  ) { }

  // public getCompanys(pageNo:number,pageSize:number,totalFilter:string,sortField:string,sortOrder:string): Observable<any> {
  //   return this.apiService.get(`Company/GetAllCompanyDetails?pageNo=${pageNo}&pageSize=${pageSize}
  //   &totalFilter=${totalFilter}&sortField=${sortField}&sortOrder=${sortOrder}`);
  // }
  // public getCompaniesTotalCount(pageNo:number,pageSize:number,totalFilter:string,sortField:string,sortOrder:string): Observable<any> {
  //   return this.apiService.get(`${environment.apiRoot}Company/GetCompaniesTotalCount?pageNo=${pageNo}&pageSize=${pageSize}
  //   &totalFilter=${totalFilter}&sortField=${sortField}&sortOrder=${sortOrder}`);
  // }
  // public deactivateCompany(companyId:number):Observable<any>{
  //   return this.apiService.get(`${environment.apiRoot}Company/DeactivateCompany?companyId=${companyId}`);
  // }
  // public activateCompany(companyId:number):Observable<any>{
  //   return this.apiService.get(`${environment.apiRoot}Company/ActivateCompany?companyId=${companyId}`);
  // }
  // public approveCompany(companyId:number,name:string):Observable<any>{
  //   return this.apiService.get(`${environment.apiRoot}Company/ApproveCompany?companyId=${companyId}&name=${name}`);
  // }
  public getAllCompanyApprovalList(userApprovalSearchParam: IGlobalSearchParam): Observable<any> {
    return this.apiService.post(`CompanyProfile/SearchCompanyApproval`, userApprovalSearchParam)
  }

  public getAllCompanyList(companySearchParam: IGlobalSearchParam): Observable<any> {
    return this.apiService.post(`CompanyProfile/SearchCompany`, companySearchParam)
  }
  public checkVendorInvoiceEligibility(id: number): Observable<any> {
    return this.apiService.get(`CompanyProfile/CheckVendorInvoiceEligibility/${id}`);
  }
  public getUserProfileDetails(id: number): Observable<any> {
    return this.apiService.get(`UserProfiles/${id}`);
  }
  public approveCompany(id: number, userDetails: IUserDetails): Observable<any> {
    return this.apiService.put(`UserProfiles/${id}`, userDetails);
  }
  public updateVendorInvoiceEligibilityStatus(vendorInvoiceEligibility: IVendorInvoiceEligibility):Observable<any>{
    return this.apiService.post(`CompanyProfile/UpdateVendorInvoieEligibilityStatus`,vendorInvoiceEligibility);
  }
  getVendorInvoiceEligibilityStatusHistory(companyId: number): Observable<any> {
    return this.apiService.get(`CompanyProfile/SearchVendorInvoieEligibilityUpdateHistory/${companyId}`);
  }
  getCompanyProfileViewByUserProfileId(id: number): Observable<any> {
    return this.apiService.get(`userProfiles/CompanyProfileViewByUserProfileId/${id}`);
  }

  activateCompany(companyid: number,activateByUserId:number): Observable<any> {
    return this.apiService.get(`CompanyProfile/ActivateCompany/${companyid}/${activateByUserId}`);
  }

  deactivateCompany(companyid: number,activateByUserId:number): Observable<any> {
    return this.apiService.get(`CompanyProfile/DeactivateCompany/${companyid}/${activateByUserId}`);
  }

  public updateCompanyNotes(companyNotes: ICompanyNotes):Observable<any>{
    return this.apiService.post(`CompanyProfile/UpdateCompanyNotes`,companyNotes);
  }

  public GetCompanyNotes(companyId: number):Observable<any>{
    return this.apiService.get(`CompanyProfile/GetCompanyNotes?companyId=${companyId}`);
  }

  public GetCompanyEditDetails(companyId:number): Observable<any> {
    return this.apiService.get(`CompanyProfile/GetCompanyEditDetails?companyId=${companyId}`);
   }
   public GetSelectedBusinessCertifications(businessCertificationIds:string): Observable<any> {
    return this.apiService.get(`Register/GetSelectedBusinessCertifications?businessCertificationIds=${businessCertificationIds}`);
   }
   public CompanyUpdateDetails(companydetails:ICompanyEdit): Observable<any> {
    return this.apiService.post(`CompanyProfile/UpdateCompanyDetails`,companydetails);
   }
   public CompanyProfileUpdate(companydetails:ICompanyProfileEdit): Observable<any> {
    return this.apiService.post(`CompanyProfile/CompanyProfileUpdate`,companydetails);
   }
   public CompanyDetailsUpdate(companydetails:ICompanyDetailsEdit): Observable<any> {
    return this.apiService.post(`CompanyProfile/CompanyDetailsUpdate`,companydetails);
   }
   public CompanyDeliveryTeamsUpdate(companydetails:ICompanyDeliveryTeamsEdit): Observable<any> {
    return this.apiService.post(`CompanyProfile/CompanyDeliveryTeamsUpdate`,companydetails);
   }
   public CompanyReferenceUpdate(companydetails:ICompanyReferenceEdit): Observable<any> {
    return this.apiService.post(`CompanyProfile/CompanyReferenceUpdate`,companydetails);
   }
   public CompanyAdminUpdate(companydetails:ICompanyAdminEdit): Observable<any> {
    return this.apiService.post(`CompanyProfile/CompanyAdminUpdate`,companydetails);
   }
   public CompanyClientDocumentUpdate(companydetails:ICompanyClientDocumentEdit): Observable<any> {
    return this.apiService.post(`CompanyProfile/CompanyClientDocumentUpdate`,companydetails);
   }
   public GetSelectedCountryVisa(tnVisaCountries:string): Observable<any> {
    return this.apiService.get(`Register/GetSelectedCountryIdsTNVisa?tnVisaCountries=${tnVisaCountries}`);
   }
   public GetSelectedClientIds(clientIds:string): Observable<any> {
    return this.apiService.get(`Register/GetSelectedClientIds?clientIds=${clientIds}`);
   }
   public GetClientForUpdate(companyId:number): Observable<any> {
    return this.apiService.get(`CompanyProfile/GetClientForUpdate?companyId=${companyId}`);
   }
   public deleteOnShoreDetails(onShoreId:number): Observable<any> {
    return this.apiService.get(`CompanyProfile/DeleteOnShoreDetails?onShoreId=${onShoreId}`);
   }
   public deleteOffShoreDetails(offShoreId:number): Observable<any> {
    return this.apiService.get(`CompanyProfile/DeleteOffShoreDetails?offShoreId=${offShoreId}`);
   }
   public deleteOnReferenceDetails(onReferenceId:number): Observable<any> {
    return this.apiService.get(`CompanyProfile/DeleteOnReferenceDetails?onReferenceId=${onReferenceId}`);
   }
   public ExportCompanyResult(companySearchParam:IGlobalSearchParam):Observable<any> {
    return this.http.post(`${environment.apiRoot}CompanyProfile/ExportCompany`, companySearchParam,
    {  
        responseType: 'blob',
        observe: 'response'
     });
  }

  public ExportCompanyApprovalResult(companySearchApprovalParam:IGlobalSearchParam):Observable<any> {
    return this.http.post(`${environment.apiRoot}CompanyProfile/ExportCompanyApproval`, companySearchApprovalParam,
    {  
        responseType: 'blob',
        observe: 'response'
     });
  }

  public viewCompanyProfile(profileId:number):Observable<any>{
    return this.apiService.get(`UserProfiles/RegisteredUserViewProfile/${profileId}`);
  }

  public GetW9FormUrl(w9FormFileName:string):Observable<any>{
    return this.http.get(`${environment.apiRoot}CompanyProfile/GetW9FormUrl?w9FormFileName=${w9FormFileName}`,
      {  
          responseType: 'blob',
          observe: 'response'
       });
  }

  public GetDDAuthorizationFileUrl(ddFileName:string):Observable<any>{
    return this.http.get(`${environment.apiRoot}CompanyProfile/GetDDAuthorizationFileUrl?ddFileName=${ddFileName}`,
      {  
          responseType: 'blob',
          observe: 'response'
       });
  }

  public GetMSAFileUrl(msaFileName:string):Observable<any>{
    return this.http.get(`${environment.apiRoot}CompanyProfile/GetMSAFileUrl?msaFileName=${msaFileName}`,
      {  
          responseType: 'blob',
          observe: 'response'
       });
  }

  public GetInsuranceFileUrl(insuranceFileName:string):Observable<any>{
    return this.http.get(`${environment.apiRoot}CompanyProfile/GetInsuranceFileUrl?insuranceFileName=${insuranceFileName}`,
      {  
          responseType: 'blob',
          observe: 'response'
       });
  }
  public getEntityType(entityTypeId:number):Observable<any>{
    return this.apiService.get(`Register/GetEntityType?entityTypeId=${entityTypeId}`)
  }
  public getClientNames(): Observable<any> {
    return this.apiService.get(`CompanyProfile/ClientCompanyList`);
   }
   public getClientNamesEdit(ClientEditId:any): Observable<any> {
    return this.apiService.get(`CompanyProfile/ClientCompanyListEdit?clientEditId=${ClientEditId}`);
   }
   public uploadW9Form(W9formToUpload: File):Observable<any>{
    const headers = new HttpHeaders().append('Content-Disposition', 'multipart/form-data');
    const input : FormData =new FormData();
    input.append("file", W9formToUpload);
    return this.http.post<any>(`${environment.apiRoot}CompanyProfile/UploadW9formToTemp`, input,{responseType:'json'});
  }

  public saveW9formUrl(filePath:string,folderName:string,companyId:number):Observable<any>{
    return this.apiService.get(`CompanyProfile/UploadW9formUrl?filePath=${filePath}&folderName=${folderName}&companyId=${companyId}`);
  }

  public saveCompanyW9formUrl(companyId:number,W9form: File):Observable<any>{
    const input : FormData =new FormData();
    input.append("file", W9form);
    return this.http.post<any>(`${environment.apiRoot}CompanyProfile/UploadCompanyW9form?companyId=${companyId}`, input,{responseType:'json'});
  }

  public uploadDDForm(DDfileToUpload: File):Observable<any>{
    const headers = new HttpHeaders().append('Content-Disposition', 'multipart/form-data');
    const input : FormData =new FormData();
    input.append("file", DDfileToUpload);
    return this.http.post<any>(`${environment.apiRoot}CompanyProfile/UploadDDFiletoTemp`, input,{responseType:'json'});
  }

  public saveDDformUrl(filePath:string,folderName:string,companyId:number):Observable<any>{
    return this.apiService.get(`CompanyProfile/UploadDDAuthorizationFileUrl?filePath=${filePath}&folderName=${folderName}&companyId=${companyId}`);
  }

  public saveCompanyDDUrl(companyId:number,W9form: File):Observable<any>{
    const input : FormData =new FormData();
    input.append("file", W9form);
    return this.http.post<any>(`${environment.apiRoot}CompanyProfile/UploadDDAuthorizationFile?companyId=${companyId}`, input,{responseType:'json'});
  }

  public uploadMSAFile(MSAfileToUpload: File):Observable<any>{
    const headers = new HttpHeaders().append('Content-Disposition', 'multipart/form-data');
    const input : FormData =new FormData();
    input.append("file", MSAfileToUpload);
    return this.http.post<any>(`${environment.apiRoot}CompanyProfile/UploadMSAFiletoTemp`, input,{responseType:'json'});
  }

  public saveMSAFileUrl(filePath:string,folderName:string,companyId:number):Observable<any>{
    return this.apiService.get(`CompanyProfile/UploadMSAFileUrl?filePath=${filePath}&folderName=${folderName}&companyId=${companyId}`);
  }

  public saveCompanyMSAUrl(companyId:number,MsaFile: File):Observable<any>{
    const input : FormData =new FormData();
    input.append("file", MsaFile);
    return this.http.post<any>(`${environment.apiRoot}CompanyProfile/UploadMSAFile?companyId=${companyId}`, input,{responseType:'json'});
  }
  public getNotesDescription(notesId:number):Observable<any>{
    return this.apiService.get(`CompanyProfile/GetNotesDescription?notesId=${notesId}`);
  }
  public updateVendorClientAssignment(companyId:number,userId): Observable<any> {
    return this.apiService.get(`CompanyProfile/UpdateVendorClientAssignment?companyId=${companyId}&userId=${userId}`);
  }
  public getPaymentTerms(paymentTermsId:number):Observable<any>{
    return this.apiService.get(`CompanyProfile/GetPaymentTerms?paymentTermsId=${paymentTermsId}`)
  }
  public getInvoiceTerms(invoiceTermsId:number):Observable<any>{
    return this.apiService.get(`CompanyProfile/GetInvoiceTerms?invoiceTermsId=${invoiceTermsId}`)
  }

  public uploadInsuranceFile(InsurancefileToUpload: File):Observable<any>{
    const headers = new HttpHeaders().append('Content-Disposition', 'multipart/form-data');
    const input : FormData =new FormData();
    input.append("file", InsurancefileToUpload);
    return this.http.post<any>(`${environment.apiRoot}CompanyProfile/UploadInsuranceFiletoTemp`, input,{responseType:'json'});
  }

  public saveCompanyInsuranceUrl(companyId:number,InsuranceFile: File):Observable<any>{
    const input : FormData =new FormData();
    input.append("file", InsuranceFile);
    return this.http.post<any>(`${environment.apiRoot}CompanyProfile/UploadInsuranceFile?companyId=${companyId}`, input,{responseType:'json'});
  }

  public getInsuranceExpiryInfo(companyId:number):Observable<any>{
    return this.apiService.get(`CompanyProfile/CheckClientInsuranceExpiry/${companyId}`)
  }

  public getCompanyApprovalStatus(approvalStatusId:number):Observable<any>{
    return this.apiService.get(`CompanyProfile/GetCompanyApprovalStatus?approvalStatusId=${approvalStatusId}`)
  }

  public checkCompanyInsuranceExpiryValidity(companyId:number):Observable<any>{
    return this.apiService.get(`CompanyProfile/CheckCompanyInsuranceExpiryValidity/${companyId}`)
  }
  public checkCompanyInsuranceExpiryValidityDashboard(companyId:number):Observable<any>{
    return this.apiService.get(`CompanyProfile/CheckCompanyInsuranceExpiryValidityDashboard/${companyId}`)
  }
  public GetClientNamesView(userId: number):Observable<any>{
    return this.apiService.get(`CompanyProfile/GetClientNames?userId=${userId}`);
  }
  public getClientListForRegistration(clientIdOnRegistration:number):Observable<any>{
    return this.apiService.get(`Register/GetClientListForRegistration?clientIdOnRegistration=${clientIdOnRegistration}`)
  }
  public getEntityTypeFromCompanyId(companyId:number):Observable<any>{
    return this.apiService.get(`CompanyProfile/GetEntityTypeFromCompanyId?companyId=${companyId}`)
  }
  public updateVendorCategory(updateCategory:IUpdateVendorCategory):Observable<any>{
    return this.apiService.post(`CompanyProfile/UpdateVendorCategory`,updateCategory);
  }
  public onVendorEmailCheck(vendorEmail: string): Observable<any> {
    return this.apiService.get(`Register/VendorEmailDuplicateCheck?vendorEmail=${vendorEmail}`);
  }
  public addVendorMSADocument(value: ICompanyDocuments): Observable<any> {
    const input =new FormData();
    input.append("companyDocuments", value.companyDocuments);
    input.append("documentTitle", value.documentTitle);
    input.append("documentTypeId",value.documentTypeId);
    input.append("companyDocReferenceId",value.companyDocReferenceId);
    input.append("createdById",value.createdById);
    input.append("companyId",value.companyId);
    console.log('input',input);
    return this.http.post<any>(`${environment.apiRoot}CompanyDocuments`, input);
  }
  public getVendorDocumentList(companyId:string):Observable<any>{
    return this.apiService.get(`CompanyDocuments/GetCompanyDocumentsByCompanyId?companyId=${companyId}`)
  }
  public deleteCompanyDocument(companyDocReferenceId:string):Observable<any>{
    return this.apiService.get(`CompanyDocuments/DeleteCompanyDocuments?companyDocReferenceId=${companyDocReferenceId}`)
  }
  public UploadInsuranceFileOnRequest(companyId:number,InsuranceFile: File):Observable<any>{
    const input : FormData =new FormData();
    input.append("file", InsuranceFile);
    return this.http.post<any>(`${environment.apiRoot}CompanyProfile/UploadInsuranceFileOnRequest?companyId=${companyId}`, input,{responseType:'json'});
  }
  public updateCOIDetails(coidetails:ICompanyCOIChangeRequestDetails): Observable<any> {
    return this.apiService.post(`CompanyProfile/CompanyCOIChangeRequest`,coidetails);
  }
  public getCOIRejctionHistory(companyId:number): Observable<any> {
    return this.apiService.get(`CompanyProfile/GetCompanyCOIRejectionHistory?companyId=${companyId}`);
  }

  public checkPermissionToViewVendor(companyId:string,userProfileId:number):Observable<any>{
    return this.apiService.get(`CompanyProfile/CheckPermissionToViewVendor/${companyId}/${userProfileId}`)
  }
  public uploadVoidChequeFile(VoidChequeFileToUpload: File):Observable<any>{
    const headers = new HttpHeaders().append('Content-Disposition', 'multipart/form-data');
    const input : FormData =new FormData();
    input.append("file", VoidChequeFileToUpload);
    return this.http.post<any>(`${environment.apiRoot}CompanyProfile/UploadVoidChequeFileToTemp`, input,{responseType:'json'});
  }
  public updateVoidChequeDetails(documentDetails:ICompanyOnboardingDocumentRequestDetails): Observable<any> {
    return this.apiService.post(`CompanyProfile/CompanyDocumentChangeRequest`,documentDetails);
  }
  public uploadI9File(I9FileToUpload: File):Observable<any>{
    const headers = new HttpHeaders().append('Content-Disposition', 'multipart/form-data');
    const input : FormData =new FormData();
    input.append("file", I9FileToUpload);
    return this.http.post<any>(`${environment.apiRoot}CompanyProfile/UploadI9FileToTemp`, input,{responseType:'json'});
  }
  public uploadEVerificationFile(EVerificationFileToUpload: File):Observable<any>{
    const headers = new HttpHeaders().append('Content-Disposition', 'multipart/form-data');
    const input : FormData =new FormData();
    input.append("file", EVerificationFileToUpload);
    return this.http.post<any>(`${environment.apiRoot}CompanyProfile/UploadEVerificationFileToUploadFileToTemp`, input,{responseType:'json'});
  }
  // public getMSAType(MSATypeId:number):Observable<any>{
  //   return this.apiService.get(`CompanyProfile/GetMSAType?invoiceTermsId=${MSATypeId}`)
  // }
  
  // public getInsuranceExhibitA(insuranceExhibitId:number):Observable<any>{
  //   return this.apiService.get(`CompanyProfile/GetInsuranceExhibit?insuranceExhibitId=${insuranceExhibitId}`)
  // }
  public uploadTempCompanyDocuments(documentDetails:ICompanyOnboardingDocumentRequestDetails): Observable<any> {
    console.log(documentDetails);
    
    const headers = new HttpHeaders().append('Content-Disposition', 'multipart/form-data');
    const input: FormData = new FormData();
    input.append("companyId", documentDetails.companyId.toString());
    input.append("documentTypeId", documentDetails.documentTypeId.toString());
    input.append("documentFile", documentDetails.documentFile);
    input.append("createdBy", documentDetails.createdBy.toString());
    input.append("modifiedBy", documentDetails.modifiedBy.toString());
    return this.http.post<any>(`${environment.apiRoot}CompanyDocuments/UploadTempCompanyDocuments`,input,{responseType:'json'});
  }
  public uploadTempCompanyDocumentsCOI(documentDetails:ICompanyOnboardingDocumentRequestDetailsCOI): Observable<any> {
    
    const headers = new HttpHeaders().append('Content-Disposition', 'multipart/form-data');
    const input: FormData = new FormData();
    input.append("companyId", documentDetails.companyId.toString());
    input.append("documentTypeId", documentDetails.documentTypeId.toString());
    input.append("documentFile", documentDetails.documentFile);
    input.append("createdBy", documentDetails.createdBy.toString());
    input.append("modifiedBy", documentDetails.modifiedBy.toString());
    input.append("glEffDate", documentDetails.glEffDate.toString());
    input.append("glExpDate", documentDetails.glExpDate.toString());
    input.append("alEffDate", documentDetails.alEffDate.toString());
    input.append("alExpDate", documentDetails.alExpDate.toString());
    input.append("ulEffDate", documentDetails.ulEffDate.toString());
    input.append("ulExpDate", documentDetails.ulExpDate.toString());
    input.append("wcEffDate", documentDetails.wcEffDate.toString());
    input.append("wcExpDate", documentDetails.wcExpDate.toString());
    input.append("plEffDate", documentDetails.plEffDate.toString());
    input.append("plExpDate", documentDetails.plExpDate.toString());
    input.append("comments", documentDetails.comments.toString());
    console.log(input);
    return this.http.post<any>(`${environment.apiRoot}CompanyDocuments/UploadTempCompanyDocuments`,input,{responseType:'json'});
  }

  public getDocumentHistoryByCompanyId(companyId:number):Observable<any>{
    return this.apiService.get(`CompanyDocuments/GetDocumentHistoryByCompanyId/${companyId}`)
  }

  downloadCompanyDocuments(vendorId: number) {
    const url = `${environment.apiRoot}CompanyDocuments/AllFilesZipDownload/${vendorId}`;
    return this.http.get(url, {
      responseType: 'blob',
    });
  }

}